export default function HeadingParagraph({ heading, paragraph, wrapperClass }) {
	return (
		<div className={wrapperClass + " py1rem"}>
			<h3 className="ass c3 fs1-5rem fs1-75rem-sm mb1rem">{heading}</h3>
			<p className="fs1rem mb2rem fs1rem">{paragraph}</p>
		</div>
	);
}
